import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from '@common/services/auth.service';

/**
 * Saves the connect URL, request id included, before anything can send the browser to sign in. The auth guard only
 * saves it when there is no token at all; a stale token passes it and is only rejected later, when app start-up
 * calls the API and gets logged out.
 */
export const rememberConnectClaudeGuard: CanActivateFn = (_route, state) => {
  inject(AuthService).setRedirectAfterLogin(state.url);
  return true;
};
